@if (!minimized) {
  <div class="panel">
    <div class="border-b border-gray-200">
      <div class="px-8 h-20 items-center flex gap-3">
        <div
          class="text-[13px] font-medium tracking-[0.3px] text-headline whitespace-nowrap overflow-hidden text-ellipsis"
        >
          {{ sidebarFilter | titleByFilesFilter: containerName : true }}
          @if (isAdvancedSearchApplied()) {
            – Search Results
          }
        </div>
        <div class="grow"></div>
        <!-- [MUST-003] 'Debug' button hidden per task; uncomment to re-enable
        <div
          class="debug"
          [class.active]="debug"
          (click)="doDebug()"
          >
          {{ debug || 'Debug' }}
        </div>
        -->
        @if (selectedTab === 'files') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appFilesListContextMenu
            [appFilesListContextMenuWithAdvancedSearch]="true"
          />
        }
        @if (selectedTab === 'folders') {
          <app-context-menu-state-indicator
            svgIcon="filters"
            appFoldersListContextMenu
            [appFoldersListContextMenuWithAdvancedSearch]="true"
          />
        }
      </div>
      @if (listState === 'tabs' && !personalFlaggedEmpty()) {
        <app-tabs
          class="panel-heading-tabs"
          [values]="tabs"
          [value]="selectedTab"
          (valueChange)="handleSelectedTabChange($event)"
        />
      }
    </div>
    <div class="panel-list">
      @if (personalFlaggedEmpty()) {
        <p class="px-8 py-8 text-sm text-subdued">No items in this view.</p>
      } @else {
        @if (selectedTab === 'files' && filesFilters) {
          <app-files-list
            [filters]="filesFilters"
            [debug]="debug"
            [showLocationBadge]="isAdvancedSearchApplied()"
            (loadInProgress)="loading = $event"
            (openFile)="handleClickFile($event)"
            (clickFile)="handleClickFile($event)"
            (doubleClickFile)="handleDoubleClickFile($event)"
          />
        }
        @if (selectedTab === 'folders' && foldersFilters) {
          <app-folders-list
            [filters]="foldersFilters"
            [debug]="debug"
            (loadInProgress)="loading = $event"
            (openFolder)="handleClickFolder($event)"
            (openFile)="handleClickFile($event)"
            (clickFolder)="handleClickFolder($event)"
            (doubleClickFolder)="handleDoubleClickFolder($event)"
          />
        }
      }
    </div>
  </div>
}
